import inputRules from './inputRules.js'

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  auth: {
    changePasswordTitle: ' Changement de mot de passe',
    password: 'Mot de passe',
    RepeatPassword: 'Répétez le mot de passe',
    pleaseFill: {
      required: 'Ce champs est requis.',
      emailOrUsername: 'Veuillez entrer votre utilisateur.',
      password: 'Veuillez entrer votre mot de passe.',
      passwordRepeat: 'Veuillez répéter votre mot de passe.',
      passwordNew: 'Veuillez entrer le nouveau mot de passe.',
      passwordNewRepeat: 'Veuillez répéter le nouveau mot de passe.',
      min8Chars: 'Le mot de passe doit contenir au moins 8 caractères.',
    },
    resetPassword: "Envoyer l'e-mail",
    logIn: 'Se connecter',
    logInToJa: `${process.env.APP_NAME} - Employés`,
    email: 'Utilisateur',
    emailExample: 'Adresse Courriel personnelle',
    changeYourPassword: 'Changer votre mot de passe',
    lostPassword: 'Mot de passe oublié?',
    passwordChangedRedirect: 'Votre mot de passe as été modifié avec succès, vous serez redirigé dans {time} secondes',
  },
  general: {
    goBack: 'Retour',
    adresse: 'Adresse',
    close: 'Fermer',
    fermer: 'fermer',
  },
  horaire: {
    nbTasks: 'tâche | tâches',
    yourTasks: 'VOS TÂCHES',
    duree: 'Durée de travail',
    heuresJour: "Nombre d'heures (jour)",
    heuresSemaine: "Nombre d'heures (semaine)",
    goToGmaps: 'Directions',
    notWorkingToday: "Vous ne travaillez pas aujourd'hui.",
    notWorkingThatDay: 'Vous ne travaillez pas ce jour là.',
    pleaseUpdate: 'Veuillez activer internet afin de charger les informations de punch',
    update: 'Mis à jour {date}',
  },
  appSettings: {
    title: "Paramètres d'application",
    dateFormat: "Format d'affichage de la date",
    debugMode: 'debugMode',
    employeMode: 'Vue employé',
  },
  mainLayout: {
    appSettings: 'Paramètres',
    dashboard: 'Profil',
    horaire: 'Horaire',
    signout: 'Déconnexion',
    punch: 'Punch',
    inspections: 'Inspections',
    profile: 'Profil',
    more: 'Plus',
    reports: 'Suivi',
    avis: 'Avis',
    presences: 'Gestion des présences',
    demandes: 'Demandes',
  },
  tutorial: {
    skip: 'Passer',
    previous: 'Précédent',
    next: 'Suivant',
    finish: 'Terminer',
  },
  punch: {
    notWorkingToday: "Vous ne travaillez pas aujourd'hui!",
    allTasksAreDone: 'Vous avez terminé, bonne fin de journée!',
    cannotLoadSchedule: 'Impossible de charger votre horaire...',
    title: 'Présence {date}',
  },
  app: {
    noInternet: 'Connection internet perdue',
    ignore: 'ignore',
    serverUnreachable: 'Le serveur est inaccessible.',
  },
  pageTitles: {
    presences: 'Gestion des présences',
    horaire: 'Votre Horaire',
    settings: "Paramètres de l'application",
    punch: 'Présence',
    profil: 'Votre Profil',
    listSuivi: 'Suivi',
    CreateSuivi: 'Créer un rapport',
    editSuivi: 'Modifier un rapport',
    demandes: 'Demandes',
  },
  presences: {
    notpunched: "Cet employé n'a pas encore punché.",
    awaitingText: {
      awaiting: 'En attente',
      awaitingData: 'Pas encore de données',
      unconfirmed: 'En attente',
      dataNotReceived: 'Données non reçues',
    },
    confirm: 'Confirmer',
    call: 'Appeler',
    awaitingConfirmation: 'En attente de confirmation',
    anomalyIndicator: 'Anomalie signalée — {severity} : {types}. Ouvrir dans la vue RH.',
  },
  notifications: {
    userPunched_in: '{employe} as confirmé son entrée: {client}',
    userPunched_out: '{employe} as confirmé sa sortie: {client}',
  },
  suivi: {
    edit: {
      confirmDeletePicture: 'confirmDeletePicture',
      failedServerSave: 'Sauvegarde serveur échouée, ce suivis as été sauvegardé dans vos brouillons.',
      successServerSave: 'Sauvegarde serveur réussie',
    },
  },
  common: {
    yes: 'Oui',
    no: 'Non',
    close: 'Fermer',
    open: 'Ouvrir',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    confirm: 'Confirmer',
  },
  // Réglages opérateur (`system_settings`). `names` et `groups` sont
  // facultatifs: un réglage sans traduction s'affiche sous son nom serveur
  // plutôt que de disparaître.
  settings: {
    title: 'Paramètres',
    refresh: 'Rafraîchir les paramètres',
    loading: 'Chargement des paramètres…',
    loadFailed: 'Impossible de charger les paramètres. Réessayez dans un instant.',
    retry: 'Réessayer',
    on: 'Activé',
    off: 'Désactivé',
    empty: 'Aucun paramètre configurable pour le moment.',
    saved: '{name} enregistré.',
    saveFailed: "Échec de l'enregistrement de {name}. La valeur précédente a été rétablie.",
    groups: {
      general: 'Général',
      punch_anomalies: 'Anomalies de punch',
    },
    // Imbriqué par groupe, jamais 'groupe.clé' en une seule clé: vue-i18n
    // résout le point comme un chemin, donc une clé littérale pointée reste
    // introuvable et le nom serveur s'affiche à la place du libellé.
    names: {
      punch_anomalies: {
        enabled: 'Détection des anomalies de punch',
      },
      general: {
        first_day_of_week: 'Premier jour de la semaine',
      },
    },
  },
  punchAnomalies: {
    fab: {
      openSituations: 'situation ouverte | situations ouvertes',
      allHandled: 'Toutes les situations sont prises en charge',
      shortLabelLoud: 'Alertes',
      shortLabelCalm: 'Situations',
      shortLabelUnavailable: 'Alertes indisponibles',
      // WCAG 2.5.3: the accessible name has to contain the visible label, or
      // speech input cannot activate the button by the word printed on it.
      loudAccessible: 'Alertes : {count} situation non prise en charge | Alertes : {count} situations non prises en charge',
      unavailable: "Alertes indisponibles — la liste n'a pas pu être chargée. Touchez pour réessayer.",
      snoozedByMe: '{count} situation reportée par vous, toujours non prise | {count} situations reportées par vous, toujours non prises',
      claimedBy: 'Situations en cours, prises en charge par {prenom}',
      claimedByTeam: "Situations en cours, prises en charge par l'équipe",
    },
    offline: {
      indicatorReconnecting: 'Reconnexion…',
      indicatorOffline: 'Hors ligne',
      bannerActionPending: 'Connexion perdue — votre action sera envoyée dès le retour du réseau.',
      bannerClaimHeld: 'Connexion perdue — vous occupez toujours cette situation, elle reste à vous.',
      retryShortly: 'Impossible de charger pour le moment. Réessayez sous peu.',
    },
    dialog: {
      title: "Situations d'urgence",
      claim: "Je m'en occupe",
      reject: 'Rejeter temporairement',
      release: 'Je me retire',
      resolve: 'Résolu',
      resolveComment: "Qu'est-il arrivé et qu'avez-vous fait?",
      // Dénouements fréquents, insérés d'un geste dans le commentaire —
      // le texte reste éditable, les bornes de longueur s'appliquent pareil.
      presetsLabel: 'Messages prédéfinis',
      presets: {
        reached: {
          label: 'Rejoint, en route',
          text: "Employé rejoint par téléphone, il est en route vers le site.",
        },
        punchError: {
          label: 'Oubli/Erreur de punch',
          text: 'Oubli ou erreur de punch.',
        },
      },
      releaseReason: 'Pourquoi vous retirez-vous?',
      releaseReasonRequired: 'Dites au prochain coach ce que vous avez déjà tenté.',
      commentRequired: 'Un commentaire est obligatoire.',
      commentTooShort: '{count} caractères — minimum {min}.',
      commentTooLong: '{count} caractères — maximum {max}.',
      commentCounter: '{count} / {max} caractères',
      alreadyClaimed: '{prenom} s\'en occupe depuis {time}',
      handover: '{prenom} s\'est retiré à {time} : « {reason} »',
      handoverUnknown: 'Retrait à {time} : « {reason} »',
      claimedByYou: 'Vous vous en occupez depuis {time} · {duration}',
      alreadyTaken: 'Cette situation vient d’être prise par un autre coach.',
      alreadyTakenBy: 'Cette situation vient d’être prise par {prenom}.',
      resolvedConfirmation: 'Situation de {name} clôturée — le commentaire a été transmis aux RH.',
      snoozed: 'Rappel dans {minutes} min',
      snoozedReason: 'Rappel prévu dans {minutes} min.',
      since: 'depuis {time}',
      call: 'Appeler',
      sms: 'Texter',
      noPhone: 'aucun numéro au dossier',
      empty: 'Aucune situation ouverte.',
      focusAnnounce: '{severity} pour {name} : {types}.',
      openedAnnounce: '{count} situation ouverte à traiter | {count} situations ouvertes à traiter',
      actionTimedOut: 'Ça prend plus de temps que prévu.',
      retry: 'Réessayer',
      actionFailed: "Une erreur est survenue. Réessayez.",
      consequences: {
        claim: 'Cette situation devient la vôtre.',
        reject: 'Reporte le rappel de {minutes} min, pour vous seulement.',
        // Avant la première réponse du serveur, la durée exacte du report est
        // inconnue : on décrit l'effet sans avancer un chiffre.
        rejectUnknownDelay: 'Reporte le rappel, pour vous seulement.',
        release: 'Vous vous retirez — tout le monde est alerté de nouveau.',
        resolve: 'Clôture la situation avec votre commentaire.',
      },
      // Événement replié d'une situation rouverte + heure de détection.
      previousEpisode: 'Événement précédent résolu à {time} · {count} anomalie | Événement précédent résolu à {time} · {count} anomalies',
      detectedAt: 'détectée à {time}',
      // Auto-régularisation : l'employé a corrigé la situation lui-même.
      clearedAt: "Régularisé par l'employé à {time}",
      // Réponse de l'employé à son propre rappel (répartition par étapes).
      employeeResponse: {
        pending: "Employé interrogé — pas encore de réponse.",
        answered: "Réponse de l'employé : {answer}",
      },
      // Durées relatives affichées dans les faits d'anomalie.
      duration: {
        minutes: '{count} min',
        hours: '{count} h',
        hoursMinutes: '{hours} h {minutes}',
      },
      // La phrase sur laquelle le coach trie, mise en évidence sur la carte :
      // l'attente manquée, pas un compteur brut. « {elapsed} » se mesure
      // toujours depuis l'échéance ratée, jamais depuis le début du travail.
      lead: {
        'ANOM-00': 'Aurait dû confirmer il y a {elapsed}',
        'ANOM-01': 'Aurait dû entrer il y a {elapsed}',
        'ANOM-02': 'Aurait dû sortir il y a {elapsed}',
        'ANOM-03': 'Trajet non confirmé',
        'ANOM-04': 'Punch à {distance} m du client',
        'ANOM-05': 'Aller-retour complet en {seconds} s',
        'ANOM-06': 'Sans aucun punch depuis {elapsed}',
      },
      // Échéance pas encore dépassée : le retard annoncé serait « 0 min ».
      // On nomme l'état, sans avancer un chiffre qui n'existe pas.
      leadPending: {
        'ANOM-00': 'Présence non confirmée',
        'ANOM-01': 'Entrée non pointée',
        'ANOM-02': 'Sortie non pointée',
      },
      // Ce qui situe la phrase ci-dessus : les heures de référence, pour que
      // le coach n'ait aucun calcul à faire. ANOM-04 et ANOM-05 sont une
      // mesure isolée, sans rien à qualifier — d'où l'absence volontaire de
      // clé pour ces deux types.
      context: {
        'ANOM-00': 'Confirmation attendue à {time}',
        'ANOM-01': 'Entrée prévue à {time}',
        'ANOM-02': 'Entrée à {time} · sortie prévue à {dueOut}',
        'ANOM-03': '{reason} · depuis {elapsed}',
        'ANOM-06': 'Sortie à {time}',
      },
      // Tâche sans durée estimée : aucune heure de sortie à annoncer.
      contextNoPlan: {
        'ANOM-02': 'Entrée à {time}',
      },
      transitReason: {
        answered_no: 'a répondu non',
        no_response: 'sans réponse',
        retries_exhausted: 'relances épuisées',
      },
      staleness: {
        pending: 'Délai dépassé — RH est alertée',
      },
      bulk: {
        enter: 'Sélection multiple',
        exit: 'Annuler la sélection',
        selectAll: 'Tout sélectionner',
        selectCase: 'Sélectionner {prenom}',
        resultClaimed: '{name} : prise en charge.',
        resultAlreadyTaken: '{name} : situation déjà prise par {prenom}.',
        resultRejected: '{name} : situation reportée.',
        resultNotPermitted: '{name} : action impossible.',
        overCapError: 'Trop de situations sélectionnées. Réduisez votre sélection et réessayez.',
        selectedOfTotal: '{selected} sélectionnés sur {total}',
        selectedCount: 'aucune sélectionnée | {count} sélectionnée | {count} sélectionnées',
      },
    },
    announce: {
      newAlert: 'Nouvelle alerte pour {name}.',
      resolved: '{name} : situation résolue.',
      claimedByOther: '{name} : prise en charge par {prenom}.',
      released: '{name} : de nouveau disponible.',
      claimLost: 'Situation déjà prise par {prenom}.',
      multiSelectOn: 'Sélection multiple activée.',
      multiSelectOff: 'Sélection multiple désactivée.',
      backOnline: 'Connexion rétablie.',
      connectionLost: 'Connexion perdue.',
    },
    walkthrough: {
      title: 'Quatre actions possibles',
      dismiss: 'Compris',
      claim: { label: "Je m'en occupe", consequence: 'Cette situation devient la vôtre.' },
      reject: { label: 'Rejeter temporairement', consequence: 'Reporte le rappel de {minutes} min, pour vous seulement.' },
      release: { label: 'Je me retire', consequence: 'Vous vous retirez — tout le monde est réalerté.' },
      resolve: { label: 'Résolu', consequence: 'Clôture la situation avec un commentaire obligatoire.' },
    },
    push: {
      explainerTitle: 'Activer les alertes push?',
      explainerBody: "Les notifications sont ce qui vous permet de réagir vite aux situations urgentes, même hors de l'application.",
      enable: 'Activer',
      later: 'Plus tard',
      missingWarning: "Notifications désactivées sur cet appareil : vous ne recevrez pas les alertes push.",
      retry: 'Réessayer',
      dismiss: 'Masquer cet avertissement',
      settingsTitle: 'Notifications push',
      statusOn: 'Activées sur cet appareil',
      statusOff: 'Désactivées sur cet appareil',
      statusBlocked: 'Bloquées — réactivez-les dans les réglages du navigateur',
      statusUnsupported: 'Non prises en charge par ce navigateur',
      statusFeatureOff: "Rien à notifier — le système d'anomalies de punch est hors fonction",
    },
    severity: {
      alert: 'Alerte',
      log: 'Info',
    },
    types: {
      'ANOM-00': 'Présence non confirmée',
      'ANOM-01': 'Entrée non pointée',
      'ANOM-02': 'Retard important chez un client',
      'ANOM-03': 'Vérification de trajet échouée',
      'ANOM-04': 'Punch hors zone',
      'ANOM-05': 'Visite éclair suspecte',
      'ANOM-06': 'Route abandonnée',
    },
    transit: {
      title: 'Êtes-vous en route?',
      question: 'Êtes-vous en route vers {client}?',
      answerBefore: 'Veuillez répondre avant {time}',
      countdown: 'Il reste {time}',
      countdownAnnounce: 'Encore {minutes} min pour répondre.',
      stakes: "Sans réponse, la vérification est comptée comme échouée. Vous pouvez être redemandé une seule fois; au dernier rappel, toute réponse referme la vérification.",
      finalNotice: "Dernier rappel — toute réponse referme la vérification, sans autre relance.",
      yes: 'Oui, je suis en route',
      yesFinal: 'Oui, fermer la vérification',
      no: 'Non',
      sending: 'Envoi…',
      queued: 'En attente de connexion — nouvel essai automatique…',
      sent: 'Envoyé.',
      ackNo: 'Noté — un coach va vous contacter.',
      ackYesExtended: 'Merci — vous serez redemandé bientôt.',
      ackYesClosed: 'Merci, votre réponse a été enregistrée.',
      lateAnswer: 'Cette vérification a déjà expiré — votre réponse est arrivée trop tard.',
      expiredAnnounce: 'Vérification expirée, sans réponse.',
    },
    // Invite l'employé à s'expliquer avant que les coachs soient alertés
    // (répartition par étapes, ANOM-01/02/06).
    employeePrompt: {
      title: 'Tout va bien?',
      question: {
        'ANOM-00': "Vous n'avez pas confirmé votre présence. Serez-vous présent chez {client}?",
        'ANOM-01': "Vous n'avez toujours pas pointé votre entrée chez {client}.",
        'ANOM-02': "Vous n'avez toujours pas pointé votre sortie chez {client}.",
        'ANOM-06': "Vous n'avez pas pointé votre entrée chez {client} après votre départ.",
        default: 'Votre punch semble inhabituel.',
      },
      answerBefore: 'Veuillez répondre avant {time}, après quoi un coach sera avisé.',
      // Une seule notification peut couvrir plusieurs questions; le dialogue
      // n'affiche que la plus ancienne, alors il annonce ce qui suit.
      queueRemaining: '{count} autre question après celle-ci | {count} autres questions après celle-ci',
      notePlaceholder: 'Détail (facultatif)',
      // Libellés par clé serveur; `forgot_punch` se lit différemment selon
      // que le punch manquant est une entrée ou une sortie.
      presets: {
        // Repli neutre : la chronologie RH peut associer un événement à une
        // anomalie dont le type est inconnu (`anomaly_id` supprimé ou non
        // résolu), alors que CaseCard.vue dispose toujours d'un anomaly.type
        // concret.
        forgot_punch: 'Oubli de punch',
        on_my_way: 'Je suis en route',
        will_be_present: 'Je serai présent',
        still_working: 'Je travaille encore, ça prend plus de temps',
        forgot_punch_in: "J'ai oublié de pointer mon entrée, je suis sur place",
        forgot_punch_out: "J'ai oublié de pointer ma sortie",
        need_help: "J'ai un problème, besoin d'aide",
      },
      sending: 'Envoi…',
      ackSent: 'Merci, votre réponse a été transmise.',
      sendFailed: "L'envoi a échoué. Réessayez.",
    },
    rh: {
      title: 'Anomalies de punch',
      cases: 'Situations',
      unresolved: 'Non résolues',
      avgClaim: 'Prise en charge moy.',
      avgResolve: 'Résolution moy.',
      employee: 'Employé',
      anomalies: 'Anomalies',
      client: 'Client',
      detectedAt: 'Détectée à',
      claimedBy: 'Prise en charge',
      resolvedBy: 'Résolue',
      comment: 'Commentaire',
      timeline: 'Chronologie complète',
      noCases: 'Aucune situation ce jour-là.',
      escalated: 'Escaladée à RH',
      cellulaire: 'cellulaire',
      telephoneFixe: 'fixe',
      factPromptedAt: 'vérification demandée à {time}',
      viewOnMap: 'Voir le punch sur la carte',
      clearedInline: 'régularisée',
      claimStaleSince: 'Prise en charge inactive depuis {time}',
      exports: {
        title: 'Exports du jour',
      },
      events: {
        anomaly_detected: 'Anomalie détectée',
        reopened: 'Situation rouverte (nouvelle alerte après résolution)',
        employee_prompted: "Employé interrogé avant l'alerte aux coachs",
        employee_responded: "Réponse de l'employé",
        anomaly_cleared: "Anomalie régularisée par l'employé",
        auto_resolved: 'Situation résolue automatiquement (régularisée)',
        notified: 'Notification envoyée',
        // Le websocket qui tient les écrans des coachs à jour — jamais une
        // alerte. Le dire explicitement : cette ligne apparaît aussi pendant
        // le délai de réponse de l'employé, avant toute alerte aux coachs.
        notified_sync: 'Écrans mis à jour chez {names} (aucune alerte)',
        claim: 'Prise en charge',
        reject: 'Rejet temporaire',
        reject_snooze: 'Rejet temporaire ({minutes} min)',
        release: 'Retrait',
        force_release: 'Retrait forcé par RH',
        resolve: 'Résolution',
        snooze_expired: 'Fin du rejet temporaire',
        escalated_rh_email: 'Courriel RH envoyé',
        escalation_skipped: 'Escalade ignorée (aucun destinataire)',
        escalation_failed: "Échec définitif de l'envoi de l'escalade",
        duplicate_suppressed: 'Répétition ignorée',
        gps_missing: 'GPS manquant au punch',
        entry_time_missing: "Heure d'entrée introuvable — règle de non-présentation inapplicable",
        recipients_extended: 'Coachs ajoutés à la liste des responsables',
        stale_released: 'Prise en charge inactive retirée par le système',
        export_performed:
          'Export CSV généré par {actor} : {from} → {to} ({count} ligne) | Export CSV généré par {actor} : {from} → {to} ({count} lignes)',
      },
      detected: {
        'ANOM-00': 'Présence non confirmée chez {client}',
        'ANOM-01': 'Entrée non pointée chez {client}',
        'ANOM-02': 'Sortie non pointée chez {client}',
        'ANOM-03': 'Vérification de trajet échouée vers {client}',
        'ANOM-04': 'Punch hors zone chez {client}',
        'ANOM-05': 'Visite éclair suspecte chez {client}',
        'ANOM-06': 'Route abandonnée vers {client}',
      },
      // Même fait sans client, pour les anomalies administratives sans site.
      detectedBare: {
        'ANOM-00': 'Présence non confirmée',
        'ANOM-01': 'Entrée non pointée',
        'ANOM-02': 'Sortie non pointée',
        'ANOM-03': 'Vérification de trajet échouée',
        'ANOM-04': 'Punch hors zone',
        'ANOM-05': 'Visite éclair suspecte',
        'ANOM-06': 'Route abandonnée',
      },
      detectedChronology: {
        'ANOM-00': 'Présence non confirmée pour ce soir ({lag} de retard)',
        'ANOM-01': '{client} : Entrée non pointée ({lag} de retard)',
        'ANOM-02': '{client} — Sur place depuis {onSite} : Sortie non pointée',
        'ANOM-02LastStop': "{client} : N'a pas punché sa dernière sortie",
        'ANOM-03': '{from} → {to} : Pas encore arrivé ({reason})',
        'ANOM-03Bare': 'Pas encore arrivé ({reason})',
        'ANOM-04': '{client} : Punch hors zone ({distance} m)',
        'ANOM-05': '{client} : Visite éclair ({seconds} s)',
        'ANOM-06': '{client} — Sans punch depuis {sinceOut} : Route abandonnée',
        'ANOM-01Bare': 'Entrée non pointée ({lag} de retard)',
        'ANOM-02Bare': 'Sur place depuis {onSite} : Sortie non pointée',
        'ANOM-02LastStopBare': "N'a pas punché sa dernière sortie",
        'ANOM-04Bare': 'Punch hors zone ({distance} m)',
        'ANOM-05Bare': 'Visite éclair ({seconds} s)',
        'ANOM-06Bare': 'Sans punch depuis {sinceOut} : Route abandonnée',
      },
      transitReasons: {
        noResponse: 'rappel sans réponse',
        answeredNo: 'a dit ne pas y aller',
        retriesExhausted: 'toujours pas arrivé après relance',
      },
      detectionSupport: {
        workVisit: 'Entrée à {start} · sortie estimée à {time}',
      },
      channels: {
        push: 'notification push',
        in_app: 'dans l\'application',
        email: 'courriel',
      },
      export: {
        button: 'Exporter (CSV)',
        title: 'Exporter les anomalies',
        from: 'Du',
        to: 'Au',
        rangeNote: 'Plage maximale : {max} jours',
        rangeExceeded: 'Plage réduite à {max} jours (maximum autorisé).',
        submit: 'Télécharger',
        cancel: 'Annuler',
        error: "L'export a échoué. Réessayez ou réduisez la plage de dates.",
      },
      warnings: {
        scan_stale: "L'analyse des anomalies n'a pas tourné depuis plus de 15 minutes — de nouvelles situations pourraient tarder à apparaître. Si ça persiste, contactez le support technique.",
        routes_budget_exhausted: 'La limite quotidienne de vérifications de trajet est atteinte — elles reprendront demain. Aucune action requise de votre part.',
        detection_off: "La détection des anomalies est désactivée — aucune nouvelle situation ne sera détectée tant qu'elle ne sera pas réactivée. Contactez un administrateur.",
        dispatch_muted: "Les alertes aux coachs sont en sourdine — ils ne reçoivent plus de notifications, mais les courriels RH continuent d'être envoyés normalement. Contactez un administrateur pour réactiver les alertes.",
        escalation_list_broken: "La liste des destinataires d'escalade est vide ou ne correspond à aucun compte RH actif — les courriels d'escalade risquent de ne rejoindre personne. Contactez un administrateur pour corriger la liste.",
      },
      notEvaluated: 'Non évaluée : la détection des anomalies n\'était pas encore activée ce jour-là (activée depuis le {date}).',
      notEvaluatedNever: "La détection des anomalies n'a jamais été activée — aucun jour n'a encore été évalué.",
      featureDisabled: "Le système d'anomalies de punch est hors fonction : aucune détection, aucune situation enregistrée. Il n'y a rien à afficher ici tant qu'il n'est pas réactivé.",
      featureDisabledAction: 'Ouvrir les paramètres système',
      timelineLoadMore: 'Afficher plus ({shown} sur {total})',
      toRecipient: 'à',
      // Un envoi groupé nomme ses destinataires tant qu'ils restent lisibles ;
      // au-delà, le surplus devient un nombre — la liste complète est déjà en
      // haut de la situation.
      recipientOthers: '{count} autre | {count} autres',
      technicalDetail: {
        show: 'Détail technique ({count} ligne) | Détail technique ({count} lignes)',
        hide: 'Masquer le détail technique',
      },
      // Vue « par événement » : la même journée relue dans l'ordre où elle
      // s'est produite, plutôt que regroupée par employé.
      table: {
        viewList: 'Par situation',
        viewTable: 'Par événement',
        noRows: 'Aucun événement ne correspond aux filtres.',
        openHint: 'Cliquez une ligne pour ouvrir la situation correspondante.',
        rowCount: '{shown} sur {total} événements',
        footnote:
          'Les événements de la journée affichée, situations et exports confondus. Pour une plage de dates, utilisez l’export CSV.',
        columns: {
          time: 'Heure',
          employee: 'Employé',
          event: 'Événement',
          anomaly: 'Anomalie',
          people: 'Acteur / destinataires',
          channel: 'Canal',
        },
        filters: {
          employee: 'Employé',
          eventType: "Type d'événement",
          severity: 'Sévérité',
          severityCount: '{count} sévérité | {count} sévérités',
          channel: 'Canal',
          search: 'Rechercher',
          technical: 'Détail technique',
          typeExport: 'Export CSV',
          typeCount: '{count} type | {count} types',
        },
      },
      // Troisième état de sévérité, entre « Alerte » et « Info » : une alerte
      // encore dans le délai de réponse de l'employé. Personne n'a été alerté,
      // mais elle deviendra bruyante seule si l'employé ne répond pas.
      awaitingEmployee: "En attente de l'employé",
      // L'employé a répondu quelque chose de rassurant, mais l'anomalie tient
      // toujours : la réponse n'annule ni l'alerte ni le délai. RH doit voir
      // « il a dit s'en venir et le punch n'est jamais entré ».
      answeredNotCleared: 'Répondu, non régularisé',
      unclaimed: 'Non prise en charge',
      previousDay: 'Jour précédent',
      nextDay: 'Jour suivant',
      dateField: 'Date (AAAA-MM-JJ)',
      openCalendar: 'Ouvrir le calendrier',
      actions: {
        forceRelease: 'Retirer le coach (RH)',
        forceReleaseConsequence: 'Retire le coach actuellement assigné — tout le monde est alerté de nouveau.',
        forceReleaseDone: '{name} : coach retiré par RH.',
        resolve: 'Résoudre (RH)',
        resolveDone: '{name} : situation résolue par RH.',
      },
      walkthrough: {
        title: "Vue d'ensemble RH",
        dismiss: 'Compris',
        warnings: {
          label: "Bannières d'état",
          consequence: "Signalent tout problème opérationnel : analyse arrêtée, détection désactivée, limite quotidienne atteinte, etc.",
        },
        cases: {
          label: 'Situations du jour',
          consequence: 'Développez une ligne pour voir le journal complet de chaque situation.',
        },
        overrides: {
          label: 'Interventions RH',
          consequence: 'Retirez un coach ou résolvez une situation directement — un commentaire est obligatoire pour résoudre.',
        },
        export: {
          label: 'Export CSV',
          consequence: 'Téléchargez les anomalies sur une plage de dates depuis le bouton de téléchargement.',
        },
      },
    },
  },
  // Le bouton « Un problème ? » et sa liste de coachs de garde — l'ancien
  // panneau dépliant au bas de l'accueil, devenu le FAB qui occupe la place
  // du bouton d'alertes quand celui-ci n'a rien à signaler.
  coachContact: {
    fab: {
      label: 'Un problème ?',
      aria: 'Un problème ? Joindre un coach à l’horaire',
    },
    dialog: {
      title: 'Joindre un coach',
      intro: 'Coachs à l’horaire aujourd’hui.',
      call: 'Appeler {name}',
      sms: 'Texter {name}',
      noPhone: 'aucun numéro au dossier',
      loading: 'Chargement des coachs…',
      // Couvre les deux sources de la liste : personne à l'horaire, et personne
      // marquée « joignable en cas de problème » dans sa fiche.
      empty: 'Personne à joindre pour le moment.',
      error: 'La liste des coachs n’a pas pu être chargée.',
      // Distinct de `error` : la liste affichée reste utilisable, elle date
      // simplement de la dernière fois qu'elle a pu être chargée.
      stale: 'Liste non actualisée — voici la dernière reçue.',
      retry: 'Réessayer',
    },
  },
  ...inputRules,
}
